import React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const Payment = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh" p={2}>
      <Card sx={{ width: '100%', maxWidth: 370 }}>
        <CardContent>
          <Typography variant="h5" component="div" gutterBottom>Contact for Payment</Typography>
          <Typography variant="body1">
            Please contact <b>9843463600</b> to activate your subscription and get access to the service.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Payment;